export const LEX_FRONT_PAGE_DASHBOARD_TEST = {
  lexFrontPageDashboardTest: {
    id: 'lex_homepage_mydash_experiment',
    variants: {
      TEST: 'my_dash_landing',
    },
  },
};

export const FRONT_PAGE_DE_EMPHASIZE_CTA_EXPERIMENT = {
  frontPageDeEmphasizeCtaExperiment: {
    id: 'reg_1719_front_page-de_emphasize_secondary_cta_experiment',
    variants: {
      VARIANT: 'variant',
    },
  },
};

export const EXPERIMENTS = {
  ...LEX_FRONT_PAGE_DASHBOARD_TEST,
  ...FRONT_PAGE_DE_EMPHASIZE_CTA_EXPERIMENT,
};
